import { useState } from "react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { DeviceMobile, UploadSimple, X } from "@phosphor-icons/react";

const MAX = 3;
const MAX_MB = 3;
const VALID = /^https?:\/\/\S+$/i;

export const ShortVideoInput = ({ value, onChange }) => {
  const [link, setLink] = useState("");
  const add = (v) => {
    if (value.length >= MAX) { toast.error(`Maximum ${MAX} vidéos courtes`); return false; }
    onChange([...value, v]);
    return true;
  };
  const addLink = () => {
    const v = link.trim();
    if (!v) return;
    if (!VALID.test(v)) return toast.error("Lien invalide : collez une adresse commençant par https://");
    if (/vm\.tiktok\.com|tiktok\.com\/t\//i.test(v)) return toast.error("Lien TikTok court : ouvrez la vidéo et copiez le lien complet (…/video/123…)");
    if (add(v)) setLink("");
  };
  const onFile = (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) return toast.error(`Vidéo trop lourde (max ${MAX_MB} Mo). Utilisez un lien TikTok.`);
    const r = new FileReader();
    r.onload = () => add(r.result);
    r.readAsDataURL(file);
  };
  return (
    <div className="mt-4" data-testid="short-video-input">
      <Label className="flex items-center gap-1"><DeviceMobile size={14} /> Vidéos format TikTok (verticales 9:16, max {MAX})</Label>
      <div className="flex gap-2 mt-1">
        <Input data-testid="short-video-link" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Lien TikTok, YouTube Shorts ou .mp4" />
        <Button type="button" data-testid="short-video-add" variant="outline" onClick={addLink}>Ajouter</Button>
        <label className="inline-flex items-center gap-1 px-3 rounded-md border border-stone-200 text-sm cursor-pointer hover:border-orange-300" data-testid="short-video-upload">
          <UploadSimple size={16} /> <span className="hidden sm:inline">Importer</span>
          <input type="file" accept="video/*" className="hidden" onChange={onFile} />
        </label>
      </div>
      {value.length > 0 && (
        <div className="flex gap-2 mt-3">
          {value.map((v, i) => (
            <div key={i} className="relative w-20 aspect-[9/16] rounded-xl bg-stone-900 text-white text-[10px] flex items-center justify-center p-1 text-center overflow-hidden" data-testid={`short-video-chip-${i}`}>
              {v.startsWith("data:") ? <video src={v} className="w-full h-full object-cover" muted /> : <span className="break-all">{v.replace(/^https?:\/\/(www\.)?/, "").slice(0, 30)}</span>}
              <button type="button" data-testid={`short-video-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute top-1 right-1 bg-black/60 rounded-full p-0.5"><X size={10} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
